import { AutomotiveAftermarketListRequestModel } from './models/automotive-aftermarket-list-filters.model';

export class AutomotiveAftermarketListLoad {
  public static readonly type = '[AutomotiveAftermarketList] Load';
  constructor(public payload: Partial<AutomotiveAftermarketListRequestModel>) {}
}

export class AutomotiveAftermarketListInitialState {
  public static readonly type = '[AutomotiveAftermarketList] Set Initial State';
}
